<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <span>{{ $t("exportar") }}</span>
    </div>
    <div>
      <el-alert description="OS FORMATOS DISPONÍVEIS SÃO .CSV, .TXT, .XLS, .HTML e .XML" type="success" :closable="false">
      </el-alert>
      <br />
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="5" v-if="user.type !== '5'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="customer">
              <CustomerList v-model="form.customer" v-bind:customerType="user.type === '2' ? 3 : 0"
                v-on:selected="selected" ref="customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('exportar')" prop="export">
              <el-select v-model="form.type" placeholder="Selecione" @change="change()">
                <el-option key="3" label="Destinatário" value="3"></el-option>
                <el-option key="5" label="Postagem" value="5"></el-option>
                <el-option key="2" label="Pré-Postagem" value="2"></el-option>
                <el-option k  ey="4" label="Remetente" value="4"></el-option>
                <el-option key="6" label="Tabela de Preço" value="6"></el-option>
                <el-option key="7" label="SRO Acompanhamento" value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="form.type === '5' || form.type === '2' || form.type === '7'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('servico')" prop="services">
              <ServicesList v-model="form.services" ref="services" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="form.type === '5' || form.type === '2' || form.type === '7'">
          <el-col :span="24">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker v-model="form.range" type="daterange" align="right" unlink-panels clearable
                range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <ExportPricetable ref="pricetableexport" v-bind:customer="form.customer" :source="form.zipcode"
        v-if="form.type === '6'" />
      <ExportSender ref="senderexport" v-else-if="tableData.length > 0" v-bind:tableData="tableData"
        v-bind:type="form.type" v-bind:customer="form.customer" v-bind:services="form.services"
        v-bind:range="form.range" />
    </div>
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "../../register/services/ServicesList.vue";
import delivery from "./data/delivery.json";
import post from "./data/post.json";
import prepost from "./data/prepost.json";
import sro from "./data/sro.json";
import senders from "./data/sender.json";
import ExportSender from "./ExportSender";
import ExportPricetable from "./ExportPricetable";
import ExportSRO from "./ExportSRO.vue";

export default {
  name: "ImportMain",
  components: {
    CustomerList,
    ExportSender,
    ServicesList,
    ExportPricetable,
    ExportSRO
},
  methods: {
    selected(customerId) {
      const vm = this;
      vm.form.customer = customerId;
      vm.form.cep = '';
      if (customerId) {
        const customerData = this.$refs.customer.customers.find(x => x.id === customerId);
        console.log(customerData);
        if (customerData) vm.form.zipcode = customerData.zipcode.zipcode;
        if (vm.$refs.pricetableexport) vm.$refs.pricetableexport.changed(vm.form.zipcode);
      }
    },
    change() {
      const vm = this;
      console.log('sro', sro)
      if (vm.form.type == "3") {
        vm.tableData = delivery;
      } else if (vm.form.type == "7") {
        vm.tableData = sro;
      } else if (vm.form.type == "5") {
        vm.tableData = post;
      } else if (vm.form.type == "2") {
        vm.tableData = prepost;
      } else if (vm.form.type == "4") {
        vm.tableData = senders;
      } else if (vm.form.type == "6") {
        setTimeout(() => {
          if (vm.$refs.pricetableexport) vm.$refs.pricetableexport.changed(vm.form.zipcode);
        }, 400)
      }
      if (vm.$refs.senderexport) vm.$refs.senderexport.saved();
    },
  },
  data() {
    return {
      tableData: [],
      form: {
        type: "",
        customer: "",
        zipcode: '',
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        services: "",
      },
      user: {
        type: "1",
      },
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.form.customer = response.customers ? response.customers.id : '';
        vm.form.zipcode = response.customers ? response.customers.zipcode.zipcode : '';
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
